export const auchanDriveOptions = {
  displayLabelsTitle: true,
  mainPicture: 'BrandPicture',
  secondaryPicture: null,
};

export default auchanDriveOptions;
